module.exports = __webpack_public_path__ + "img/help-top.ecc2d8b4.svg";